import { render, staticRenderFns } from "./pay-slip.vue?vue&type=template&id=4c9045b4&"
import script from "./pay-slip.vue?vue&type=script&lang=js&"
export * from "./pay-slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports